import {
  Swiper, Lazy, Navigation, Pagination,
} from 'swiper';
import $ from 'jquery';
import { getBreakpoints } from '../utils/utils';

const prevEl = '.slider-box__navigation--prev';
const nextEl = '.slider-box__navigation--next';
const containerEl = '.slider-box__container';
const paginationEl = '.slider-box__pagination';
const listEl = '.slider-box__list';
const preloaderClass = 'tile-slide__preloader';
const swipers = [];
const defaultSlidesPerView = 1;
const defaultSpaceBetween = 0;

let lastWindowWidth = window.innerWidth;
let booted = false;

function getSliderBreakpoints(options) {
  return {
    0: {
      slidesPerView: 1,
      loop: true,
    },
    768: {
      slidesPerView: (options.slidesPerView === 1) ? 1 : 2,
      loop: true,
    },
    992: {
      slidesPerView: options.slidesPerView,
    },
  };
}

function updateFocusElement(swiper, slidesPerView) {
  const focusAbleElements = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
  const focusAbles = swiper.$el.children('.swiper-wrapper').find(focusAbleElements);
  focusAbles.attr('tabindex', '-1');

  for (let i = swiper.activeIndex; i < (swiper.activeIndex + slidesPerView); i++) {
    const slideFocusAbles = $(swiper.slides[i]).find(focusAbleElements);
    slideFocusAbles.attr('tabindex', '0');
  }
}

function isInnerNavigation($slider) {
  const container = $slider.find(containerEl);
  const sliderPadding = container.innerWidth() - container.width();
  const emptySliderSpace = container.outerWidth(true) - container.innerWidth();
  // eslint-disable-next-line max-len
  const navigationWidth = $slider.find(prevEl).outerWidth(true) + $slider.find(nextEl).outerWidth(true);

  return emptySliderSpace > navigationWidth + sliderPadding;
}

function checkNavigation($slider) {
  const isInner = isInnerNavigation($slider);
  $slider.find(prevEl).toggleClass('slider-box__navigation--prev-inner', !isInner);
  $slider.find(nextEl).toggleClass('slider-box__navigation--next-inner', !isInner);
}

function bindPaginationA11y($slider, swiper) {
  $slider.find('.swiper-pagination-bullet').each(function (index) {
    $(this)
      .attr({ id: index, tabindex: 0 })
      .on('keydown', (event) => {
        if (event.key === 'Enter') {
          swiper.slideToLoop(index);
        }
      });
  });
}

function initSwiper($slider) {
  const options = $slider.data('options') || {};
  const isAutoHeight = $slider.find('.slider-box__list--celebration').length > 0
    || $slider.find('.slider-box__list--medium').length > 0;
  const slidesPerView = options.slidesPerView || defaultSlidesPerView;
  const spaceBetween = options.spaceBetween || defaultSpaceBetween;
  const pagination = !!options.pagination;
  const notDuplicatedSlides = $slider.find('.swiper-slide').not('.swiper-slide-duplicate').length;
  const list = $slider.find(listEl)[0];

  if (!list) {
    return;
  }

  const swiper = new Swiper(list, {
    init: false,
    slidesPerView,
    spaceBetween,
    loop: true,
    navigation: {
      nextEl: $slider.find(nextEl)[0],
      prevEl: $slider.find(prevEl)[0],
    },
    keyboard: {
      enabled: true,
    },
    lazy: {
      preloaderClass,
    },
    autoHeight: !isAutoHeight,
    modules: [Lazy, Pagination, Navigation],
    breakpoints: getSliderBreakpoints(options),
    on: {
      slideChange() {
        // Scope cleanup to THIS slider — global $('.content-video') killed
        // unrelated videos site-wide during loop-mode init (MSPRET-8448).
        $(this.el).find('.content-video').each(function () {
          $(this).find('iframe, video').remove();
          $(this).find('picture').css({ opacity: 1, display: 'block' });
        });
      },
      slideChangeTransitionStart() {
        const { $wrapperEl, params } = this;
        $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}`)
          .each(function () {
            const idx = this.getAttribute('data-swiper-slide-index');
            this.innerHTML = $wrapperEl.children(
              `.${params.slideClass}[data-swiper-slide-index="${idx}"]:not(.${params.slideDuplicateClass})`,
            ).html();
          });
        updateFocusElement(this, slidesPerView);
      },
      slideChangeTransitionEnd() {
        this.slideToLoop(this.realIndex, 0, false);
        updateFocusElement(this, slidesPerView);
      },
    },
  });

  if (pagination) {
    swiper.params.pagination.clickable = true;
    const [paginationNode] = $slider.find(paginationEl);
    swiper.params.pagination.el = paginationNode;
  }

  swiper.init();

  if (pagination) {
    bindPaginationA11y($slider, swiper);
  }

  // Disable slider if Triple Box Slides template has only 3 slides (desktop)
  if ($(window).width() > getBreakpoints().lg && notDuplicatedSlides <= 3) {
    $slider.find('.swiper-slide.swiper-slide-duplicate').remove();
    swiper.disable();
  }

  swipers.push(swiper);
  checkNavigation($slider);
}

function destroyAll() {
  swipers.forEach((swiper) => {
    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
    }
  });
  swipers.length = 0;
}

function updateAll() {
  swipers.forEach((swiper) => {
    if (swiper && !swiper.destroyed) {
      swiper.update();
    }
  });
  $('.slider-box').each(function () {
    checkNavigation($(this));
  });
}

function initAll() {
  destroyAll();
  $('.slider-box').each(function () {
    initSwiper($(this));
  });
}

function boot() {
  if (booted) {
    return;
  }
  booted = true;

  initAll();
  // Delayed CSS / images can leave wrong measurements on first paint;
  // MSPRET-8473 synthetic resize is same-width, so we update after layout.
  requestAnimationFrame(updateAll);
}

if (document.readyState === 'complete') {
  boot();
} else {
  $(window).on('load', boot);
}

$(window).on('resize', () => {
  const widthChanged = window.innerWidth !== lastWindowWidth;
  lastWindowWidth = window.innerWidth;

  if (!booted) {
    boot();
    return;
  }

  if (widthChanged) {
    initAll();
  } else {
    updateAll();
  }
});

export default true;
